import React from 'react';
import { MetaText } from '@hm-group/fabric-components';
import cn from 'classnames';
const Separator = ({ isCurrentPage, separator = '/', className }) => {
    if (isCurrentPage)
        return null;
    return (React.createElement(MetaText, { role: "presentation", className: cn(className && className) }, separator));
};
export default Separator;
//# sourceMappingURL=Separator.js.map